import { StockStatus } from 'models/StockModel';

export const nonEditableStatuses = [
    StockStatus.Received,
    StockStatus.Canceled,
    StockStatus.Lost,
];

export const japanMakers = [
    'TOYOTA',
    'SUBARU',
    'NISSAN',
    'MAZDA',
    'HONDA',
    'SUZUKI',
    'DAIHATSU',
    'HINO',
    'MITSUBISHI',
    'MITSUOKA',
    'KAWASAKI',
    'KUBOTA',
    'IHI',
    'LEXUS',
    'ISUZU',
    'HITACHI',
    'KOBELCO',
    'KOMATSU',
    'SUMITOMO',
    'YANMAR',
];

export const vehiclesWithCountry = [
    'sedan',
    'bus',
    'van',
    'station_wagon',
];

export const specialModels = {
    IPSUM: 'sedan',
    WISH: 'sedan',
    ISIS: 'sedan',
    ESTIMA: 'van',
    ODYSSEY: 'van',
    ALPHARD: 'van',
    'BONGO FRIENDEE': 'van',
    VELLFIRE: 'van',
    'LAND CRUISER PRADO': 'van',
    SAFARI: 'van',
    'FJ CRUISER': 'van',
    RX: 'van',
    PAJERO: 'van',
    HIACE: 'van',
    CARAVAN: 'van',
    STEPWAGON: 'van',
};
